import React, { useState, useEffect, Suspense } from "react";
import { SpinnerCircularFixed } from "../../assets/spinner/SpinnerCircularFixed";
import LayoutHOC from "./hocs/LayoutHOC";
import WelcomePage from "./WelcomePage";
import BannerSplitPage from "./BannerSplitPage";
import BannerLandscapePage from "./BannerLandscapePage";
import ValuesPage from "./ValuesPage";
import { useParams } from "react-router-dom";
import TaglinePage from "./TaglinePage";
import SideBySidePage from "./SideBySidePage";
import CarouselCustomizationPage from "./carousel/SlideListView/CarouselCustomizationPage";
import { useUnsavedChanges } from "./hooks/useUnsavedChangesGuard";
import customizationIcon from "../../assets/management/layout.svg";

const LoadingComponent: React.FC = () => (
  <div className="spinner-div spinnerReport">
    <SpinnerCircularFixed className='' size={35} thickness={140} speed={120} color="rgba(203, 216, 234, 1)" secondaryColor="rgba(0, 0, 0, 0.44)" />
  </div>
);

export default function StoreCustomizationContainer({ storeId, storeName, initialTab }: { storeId?: string; storeName?: string; initialTab?: string }) {
  const [loading, setLoading] = useState(true);
  const { storeId: storeIdParams } = useParams<{ storeId: string }>();
  const [activeTab, setActiveTab] = useState(initialTab || "welcome");

  const { runWithConfirmation } = useUnsavedChanges();

  const handleTabChange = (tab: string) => {
    runWithConfirmation(() => setActiveTab(tab));
  };

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 500);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (initialTab) setActiveTab(initialTab);
  }, [initialTab]);

  const renderContent = () => {
    let ComponentToRender;

    switch (activeTab) {
      case "welcome":
        ComponentToRender = <WelcomePage loading={loading} onTabChange={handleTabChange} />;
        break;
      case "carousel":
        ComponentToRender = <CarouselCustomizationPage model={{ storeId: storeId || storeIdParams || '' }} />;
        break;
      case "banner-landscape":
        ComponentToRender = <BannerLandscapePage model={{ storeId: storeId || storeIdParams || '' }} />;
        break;
      // case "central-categories":
      //   ComponentToRender = <CentralCategoriesPage />;
      //   break;
      case "values":
           ComponentToRender = <ValuesPage model={{ storeId: storeId || storeIdParams || '' }} />;
           break;
      case "banner-split":
           ComponentToRender = <BannerSplitPage model={{ storeId: storeId || storeIdParams || '' }} />;
           break;
      case "tagline":
        ComponentToRender = <TaglinePage model={{ storeId: storeId || storeIdParams || '' }} />;
        break;
      case "side-by-side":
        ComponentToRender = <SideBySidePage model={{ storeId: storeId || storeIdParams || '' }} />;
        break;
      default:
        ComponentToRender = <WelcomePage loading={loading} onTabChange={handleTabChange} />;
    }

    return (
      <div className="customization-tool-container">
        <div className="customization-tool-container__heading">
          {storeName && <p>Shopify Stores/{storeName}</p>}
          <h4 className="title"><img src={customizationIcon} alt="" /> Customization</h4>
        </div>
        <LayoutHOC
          mainContent={
            <Suspense fallback={<LoadingComponent />}>
              {ComponentToRender}
            </Suspense>
          }
          onTabChange={handleTabChange}
          activeTab={activeTab}
        />
      </div>
    );
  };

  return (
    <div>
      {loading ? (
        <LoadingComponent />
      ) : (
        renderContent()
      )}

    </div>
  );
}
